import React, { useEffect, useState, useContext } from "react";
import { Redirect, useLocation } from "react-router";
import PasswordUpdateForm from "@Components/shared/PasswordUpdateForm";
import "@Styles/pages/passwordResetPage.scss";
import PageHelmet from "@Components/shared/PageHelmet";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

const PasswordResetPage: React.FC = () => {
    const location = useLocation();
    const [isResetPayload, setIsResetPayload] = useState(true);
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;

    const extractPayload = (search: string) => {
        return search.split("?account=")[1];
    };

    useEffect(() => {
        const resetPayload = extractPayload(location.search);
        if (!resetPayload || resetPayload === "" || resetPayload.length === 0) {
            setIsResetPayload(false);
        }
    }, []);

    if (!isResetPayload) {
        return <Redirect to="/login" />;
    }

    return (
        <div
            style={
                isDesktop ? { alignItems: "center", justifyContent: "center", display: "flex", height: "100%" } : null
            }
        >
            <article className="password-reset-container">
                <PageHelmet name={"Reset Password"} />
                <PasswordUpdateForm type="reset" />
            </article>
        </div>
    );
};

export default PasswordResetPage;
